import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-primary text-primary-foreground"
    >
      <div className="grain absolute inset-0 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 py-16 sm:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <p className="overline !text-accent mb-4">Faith • Family • Finance</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl lg:text-7xl leading-[0.98] tracking-tight">
              A promise <em className="not-italic text-accent">kept</em>,
              <br /> for generations.
            </h2>
          </div>

          <div className="lg:col-span-2">
            <p className="text-xs uppercase tracking-[0.2em] text-primary-foreground/60 mb-4">Explore</p>
            <ul className="space-y-3 text-sm">
              <li><a href="/#plans" className="hover:text-accent transition-colors">Plans</a></li>
              <li><a href="/#process" className="hover:text-accent transition-colors">How it works</a></li>
              <li><a href="/#faq" className="hover:text-accent transition-colors">FAQ</a></li>
              <li><Link to="/about" className="hover:text-accent transition-colors">About</Link></li>
              <li>
                <a
                  href="https://tevahtech.com/signup/D0404"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent transition-colors"
                >
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.2em] text-primary-foreground/60 mb-4">Reach a real human</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3"><Phone className="h-4 w-4 text-accent" strokeWidth={1.5} /> 408-800-5614</li>
              <li className="flex items-center gap-3"><Mail className="h-4 w-4 text-accent" strokeWidth={1.5} /> Hello@FaithFamilyFinance.us</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-primary-foreground/15 flex flex-col md:flex-row gap-4 md:items-center md:justify-between text-xs text-primary-foreground/60">
          <p>© {new Date().getFullYear()} Faith Family Finance. Licensed insurance brokerage. All rights reserved.</p>
          <p>Carrier-neutral • A-rated partners only • NPN #21629981</p>
        </div>
      </div>
    </footer>
  );
}
